import {makeSystemModePath} from './shared/serverFunctions';

/**
 * Secondary Filters by selection:
 *     Discount
 *     Item Sales
 *     Sales Summary
 *     VIP Trends
 */
export const RESOURCES = {
    "DiscountFilterByItems": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Discount Filter by Items",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/discountsFilterByItems/" + startEndOffset
            }
        }
    },
    "ItemSalesFilterByItems": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Filter by Items",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumFilterbyItems/" + startEndOffset
            }
        }
    },
    "SalesSummaryFilterByItems": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Filter by Items",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumFilterbyItems/" + startEndOffset
            }
        }
    },
    "VIPTrendsFilterByItems": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Trends Filter by Items",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/vipTrendsFilterByItems/" + startEndOffset
            }
        }
    },
    "FilterByItems": {
        GET_LIST: function () {
            let systemMode = makeSystemModePath();

            // @TODO change without dates once API exists
            console.log('FilterByItems ');

            let startEndOffset = "2021-12-20/2021-12-21/-07:00";
            // 2021-12-07/2021-12-24/-07:00
            // 2019-09-04/2019-09-04/-08:00
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Filter by Items",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumFilterbyItems/" + startEndOffset
            }
        }
    },
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "SalesSummaryFilterByItems"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseFiltersResourceMap.js